<template>
  <div class="statement-react">
    <add-button v-bind:statement="statement" @toggleOn="addFormStatement(statement)" />
  </div>
</template>

<script>
  import StatementAdd from "./StatementAdd.ts";

  export default StatementAdd;
</script>
